import React from "react";
import { useTranslation } from "react-i18next";

interface TopUser {
  personalCode: string;
  name: string | null;
  count: number;
}

interface Props {
  topUsers: TopUser[] | undefined;
}

export function TopUsersCard({ topUsers }: Props) {
  const { t } = useTranslation();

  if (!topUsers || topUsers.length === 0) return null;

  return (
    <div className="p-4 rounded-xl border border-border bg-card">
      <div className="text-xs text-muted-foreground uppercase tracking-wide mb-3">
        {t("admin.stats.topUsers")}
      </div>
      <ul className="space-y-2">
        {topUsers.map((u) => (
          <li key={u.personalCode} className="flex items-center justify-between gap-3 text-sm">
            <span className="truncate">
              <span className="font-medium text-foreground">{u.name ?? "—"}</span>
              <span className="text-xs font-mono text-muted-foreground ml-2">{u.personalCode}</span>
            </span>
            <span className="text-muted-foreground whitespace-nowrap">{u.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
